module.exports = __webpack_public_path__ + "img/no-data.edbbd919.png";